import Axios from "axios";
import { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { DataGrid, GridToolbar  } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from "@mui/material";
import { MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
const Products = () => {

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editProduct, setEditProduct] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [newProduct, setNewProduct] = useState({
    name: "",
    expiring_date: "",
  });

  const [data, setData] = useState([]);          // Original products
  const [mappedData, setMappedData] = useState([]); // Final mapped products
  const [loading, setLoading] = useState(true);

  // ✅ Fetch both products and together
  useEffect(() => {
    const fetchData = async () => {
      try {
        const productsRes = await Axios.get("https://store.petplanet.rw/api/products");

        const productsData = productsRes.data || [];
        
        setData(productsData);
        setMappedData(productsData);
                
        setData(productsData);
      } catch (error) {
        console.error("Error fetching products", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // ✅ Refresh data after add/edit
  const refreshData = async () => {
    try {
      const res = await Axios.get("https://store.petplanet.rw/api/products");
      setMappedData(res.data || []);
    } catch (error) {
      console.error("Error refreshing data:", error);
    }
  };

  // ✅ Handle Add Product
  const handleAddProduct = async () => {
    if (!newProduct.name) {
      alert("Please enter product name and select a expiring date");
      return;
    }

    try {
         await Axios.post("https://store.petplanet.rw/api/products", {
      name: newProduct.name,
      expiring_date: newProduct.expiring_date,
    });

      alert("Product added successfully!");
      setIsAddModalOpen(false);
      setNewProduct({ name: "", expiring_date: "" });
      refreshData(); // ✅ update table
    } catch (error) {
      console.error("Error adding product:", error.response?.data || error);
      alert("Failed to add product");
    }
  };

  // ✅ Handle Edit Product
  const handleSave = async () => {
    if (!editProduct) return;

    const updatedProduct = {
      name: editProduct.name,
      expiring_date: editProduct.expiring_date,
    };
    try {
      await Axios.put(
        `https://store.petplanet.rw/api/products/${editProduct.id}`,
        updatedProduct,
        { headers: { "Content-Type": "application/json" } }
      );

      alert("Product updated successfully!");
      setIsEditModalOpen(false);
      refreshData(); // ✅ update mapped data
    } catch (error) {
      console.error("Error updating product:", error.response?.data || error);
    }
  };


  

const handleDelete = async (id) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this product?");
  if (!confirmDelete) return;

  try {
    await Axios.delete(`https://store.petplanet.rw/api/products/${id}`);
    alert("Product deleted successfully!");

    // Remove the deleted product from state immediately
    setData((prevData) => prevData.filter((item) => item.id !== id));
  } catch (error) {
    console.error("Failed to delete product:", error);
    alert("Error deleting product");
  }
};


  const columns = [
    { field: "name", 
      headerName: "Product Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "buying_price",
      headerName: "Buying Price",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 1,
      renderCell: (params) => {
        const value = parseFloat(params.value);
        const formattedValue = isNaN(value) ? "0" : value.toLocaleString(); // adds commas
        return (
         <Box display="flex" justifyContent="flex-start" alignItems="center">
            {formattedValue} <span style={{ color: tokens.blueAccent[300], fontWeight: "bold", marginLeft: "4px" }}>RWF</span>
          </Box>
        );
      }
    },
    {
      field: "selling_price",
      headerName: "Selling Price",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 1,
      renderCell: (params) => {
        const value = parseFloat(params.value);
        const formattedValue = isNaN(value) ? "0" : value.toLocaleString(); // adds commas
        return (
          <Box display="flex" justifyContent="flex-start" alignItems="center">
            {formattedValue} <span style={{ color: "#fbc02d", fontWeight: "bold", marginLeft: "4px" }}>RWF</span>
          </Box>
        );
      }
    },
    {
      field: "quantity",
      headerName: "Instock",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "expiring_date",
      headerName: "Expiring Date",
      flex: 1,
    },
    {
      field: "",
      headerName: "Actions",
      align:"left",
      renderCell: (params) => {
        return (
          <Box
            paddingLeft="20px"
            paddingRight="20px"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <IconButton onClick={() => {
                        setEditProduct(params.row); // Save the clicked row's data
                        setIsEditModalOpen(true);   // Open the modal
                      }} 
                      color="secondary"
            >
              <EditOutlinedIcon />
            </IconButton>
            <IconButton onClick={() => handleDelete(params.row.id)} style={{color:"#FF0000"}}>
              <DeleteOutlinedIcon />
            </IconButton>
          </Box>
        );
      },
      headerClassName: "action-column--header",  // Add a custom class to the header of the Actions column
    },
  ];
  return (
    <>
    <Box m="20px" mt="80px">
      <Box display="flex" alignItems="center" justifyContent="space-between">
      <Header title="Products" 
         subtitle="1,000 Products" />
      <IconButton
          onClick={() => {
            setNewProduct({ 
              name: "", 
            }); // reset form
            setIsAddModalOpen(true);   // Open the modal
          }} 
          sx={{
            fontSize: "13px",
            backgroundColor: tokens.redAccent[400],
            border: "none",
            color: tokens.grey[100],
            padding: "14px",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
            marginTop: "-13px",
            transition: "all 0.3s ease",
            "&:hover": {
              outline: `2px solid ${tokens.redAccent[400]}`,
              outlineOffset: "1px",
              backgroundColor: tokens.redAccent[200],
            },
            "&:active": {
              outline: `2px solid ${tokens.redAccent[500]}`,
              transform: "scale(0.97)",
            },
          }}
          >
          Add Product<AddOutlinedIcon fontSize="15px" />
      </IconButton>
      </Box>
      <Box
        m="20px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: tokens.grey[800],
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: tokens.grey[100],
          },
          "& .MuiCheckbox-root": {
            border: "none",
            color: `${tokens.redAccent[400]} !important`,
          },
          "& .MuiDataGrid-columnHeader.action-column--header": {
            background: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: `${tokens.grey[900]} !important`,
            fontSize: "12px",
          },
          "& .MuiDataGrid-columnSeparator--resizable": {
            color: `${tokens.blueAccent[100]} !important`,
          }
        }}
      >
        <DataGrid
            checkboxSelection 
            loading={loading}
            rows={mappedData} 
            columns={columns}  
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true, // Ensures the filter search bar is shown
              },
            }}
            sx={{
                  "& .MuiDataGrid-toolbarContainer": {
                    display: "flex",
                    justifyContent: "space-between",
                  },
                  // Styling for all buttons within the DataGrid
                  "& .MuiButton-root": {
                    padding: "8px 15px", // Adjust padding for all button
                    textTransform: "none", // Keep text in normal case
                  },
                  "& .MuiButton-text": {
                    color: tokens.blueAccent[400], // Text color for text buttons
                  },
            }}
         />
      </Box>
    </Box>
    <Dialog sx={{
                  "& .MuiDialog-paper": {
                    width:"800px",
                    position: "absolute",
                    top: "0",  // Customize the distance from the top (e.g., 20% from the top)
                    left: "60%",
                    transform: "translateX(-50%)",  // Center horizontally
                  }
              }} open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
        <DialogTitle style={{ background: tokens.redAccent[200], color: tokens.blueAccent[400], fontSize: "17px"}}>Edit Product</DialogTitle>
        <DialogContent style={{ background: tokens.grey[100], padding:"20px 10px"} }>
          <Box style={{display:"flex", justifyContent: "space-between", gap:"20px"}}>
            <TextField
              label="Product Name"
              fullWidth
              value={editProduct?.name || ""}
              onChange={(e) => setEditProduct({ ...editProduct, name: e.target.value })}
              margin="normal"
            />
    
          </Box>
          <Box style={{display:"flex", justifyContent:"space-between", marginTop:"10px", gap:"20px"}}>
            <TextField
              margin="normal"
              label="Buying Price"
              type="number"
              fullWidth
              value={editProduct?.buying_price || ""}
              InputProps={{ readOnly: true }}   // 👈 Makes it view-only
            />
            <TextField
              margin="normal"
              label="Selling Price"
              type="number"
              fullWidth
              value={editProduct?.selling_price || ""}
              InputProps={{ readOnly: true }}   // 👈 Makes it view-only
            />
            <TextField
              margin="normal"
              label="Quantity"
              type="number"
              fullWidth
              value={editProduct?.quantity || ""}
              InputProps={{ readOnly: true }}   // 👈 Makes it view-only
            />
            <TextField
              margin="normal"
              label="Expiring Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={editProduct?.expiring_date || ""}
              onChange={(e) =>
                setEditProduct({ ...editProduct, expiring_date: e.target.value })
              }
            />
        </Box>

        </DialogContent>
    
        <DialogActions style={{background:tokens.redAccent[200]}}>
          <Button style={{color: tokens.blueAccent[400]}} onClick={() => setIsEditModalOpen(false)}>Cancel</Button>
          <Button style={{color: tokens.blueAccent[400]}} onClick={handleSave}>Save</Button>
        </DialogActions>
    </Dialog>

    <Dialog sx={{
                  "& .MuiDialog-paper": {
                    width:"500px",
                    position: "absolute",
                    top: "0",  // Customize the distance from the top (e.g., 20% from the top)
                    left: "60%",
                    transform: "translateX(-50%)",  // Center horizontally
                  }
                }} open={isAddModalOpen} onClose={() => setIsAddModalOpen(false)}>
      <DialogTitle fontSize="20px" backgroundColor={tokens.redAccent[200]} color={tokens.blueAccent[400]}>Add New Product</DialogTitle>
      <DialogContent style={{ background: tokens.grey[100], padding:"20px 30px"} }>
        <TextField
          margin="normal"
          label="Product Name"
          fullWidth
          value={newProduct.name}
          onChange={(e) =>
            setNewProduct({ ...newProduct, name: e.target.value })
          }
        />
        <TextField
          margin="normal"
          label="Expiring Date"
          type="date"
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={newProduct.expiring_date}
          onChange={(e) =>
            setNewProduct({ ...newProduct, expiring_date: e.target.value })
          }
        />
      </DialogContent>
      <DialogActions style={{background:tokens.redAccent[200]}}>
        <Button 
            style={{color: tokens.blueAccent[400]}} 
            onClick={() => setIsAddModalOpen(false)}
        >
          Cancel
        </Button>
        <Button
          style={{color: tokens.blueAccent[400]}}
          onClick={handleAddProduct}
        >
          SAVE
        </Button>
      </DialogActions>
    </Dialog>

  </>
  
  );
};

export default Products;
